module.exports = __webpack_public_path__ + "media/images/icons/telephone-af20bee7dbb0d23831627dd70d5d0867.png";